import baseText from '@elegantstack/solid-ui-theme/src/text'

export default {
  ...baseText,
  h2: {
    ...baseText.h2,
    mx: 0
  }
}
